/**
 * Labstep
 *
 * @module components/Chemical/Form/ShowEdit/IsLimiting
 * @desc ShowEditIsLimiting for Chemical
 */

import { EntityActionUpdateCheckbox } from 'labstep-web/components/Entity/Action/Update/Checkbox';
import type React from 'react';
import type { ChemicalFormShowEditIsLimitingProps } from './types';

export const ChemicalFormShowEditIsLimiting: React.FC<
  ChemicalFormShowEditIsLimitingProps
> = ({ chemical }) => (
  <EntityActionUpdateCheckbox
    entity={chemical.molecule}
    isChecked={chemical.is_limiting}
    field="limiting_chemical_guid"
    fieldValue={chemical.guid}
    optimistic
    radio
  />
);
